import type { ScreenFactory } from "../../taskScreenRegistry";

import { createFuneralCostsScreens } from "./funeral_costs";
import { createOngoingCostsScreens } from "./ongoing_costs";

export const expensesTasks: Record<string, ScreenFactory> = {
  funeral_costs: createFuneralCostsScreens,
  ongoing_costs: createOngoingCostsScreens,
};
